import { AusActions } from "@aus/Store/AusState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<AusActions>>;

export const ClearSearch: HandlerType = props => {
    props.dispatch({
        type: "Pages/WorkOrderHistory/ClearParameter",
    });
};

export const chain = [ClearSearch];

const clearSearch = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearSearch");
export default clearSearch;
